// Hover layer for the /trends leader maps (trends/_leader_map): the shared
// navy pill naming the area's ranked chains, the hovered area's outline drawn
// on top, and a legend entry fading every area and logo its chain doesn't
// hold. Fills, the view switch, logos and links are server HTML and CSS —
// without this module a map only loses its hover.
import { createTip } from "./tooltip"

const SVG_NS = "http://www.w3.org/2000/svg"

export function initTrendsLeaderMaps() {
  document.querySelectorAll("[data-trends-leader-map]").forEach(mount)
}

function mount(root) {
  const canvas = root.querySelector("[data-leader-map-canvas]")
  const svg = canvas && canvas.querySelector("svg")
  if (!svg) return

  const shapes = svg.querySelector("[data-area-shapes]")
  const tip = createTip(canvas, { multiline: true })
  // Above the outlines and a state's border, under the logo tiles.
  const outline = document.createElementNS(SVG_NS, "path")
  outline.setAttribute("class", "area-hover")
  outline.style.display = "none"
  const below = svg.querySelector(".leader-map-outline") || shapes
  below.after(outline)

  const hide = () => {
    tip.hide()
    outline.style.display = "none"
  }

  canvas.addEventListener("pointermove", (event) => {
    const hit = event.target.closest("[data-area]")
    if (!hit) return hide()

    const box = canvas.getBoundingClientRect()
    tip.show(event.clientX - box.left, event.clientY - box.top, hit.dataset.tip)
    // A metro's code is its Census title ("Coeur d'Alene, ID").
    const shape = shapes.querySelector(`[data-area="${CSS.escape(hit.dataset.area)}"] .area-shape`)
    outline.setAttribute("d", shape.getAttribute("d"))
    outline.style.display = ""
  })
  canvas.addEventListener("pointerleave", hide)

  const highlight = (view, chain) => {
    svg.querySelectorAll("[data-hit]").forEach((el) => el.removeAttribute("data-hit"))
    if (view === null) return canvas.removeAttribute("data-dim")

    canvas.setAttribute("data-dim", "")
    const held = [
      ...shapes.querySelectorAll(`[data-c${view}="${chain}"]`),
      ...svg.querySelectorAll(`[data-map-view="${view}"] [data-tile][data-c="${chain}"]`)
    ]
    held.forEach((el) => el.setAttribute("data-hit", ""))
  }

  root.querySelectorAll("[data-legend-chain]").forEach((entry) => {
    entry.addEventListener("pointerenter", () => highlight(entry.dataset.view, entry.dataset.legendChain))
    entry.addEventListener("pointerleave", () => highlight(null))
  })
}
